import {
  feedTokenStatusResponseSchema,
  mintFeedTokenResponseSchema,
  type FeedTokenStatusResponse,
} from '@awwyeah/shared';

/**
 * REST client for the WS-22 outbound calendar feed's token lifecycle. All three calls are
 * session-authed (`credentials: 'include'`, matching `push/api.ts`'s `sendPoke`); the
 * fourth endpoint (the `.ics` fetch itself) has no client-side wrapper — it's a plain URL
 * handed to Google/iCloud, never fetched by this app.
 */

export async function fetchFeedTokenStatus(): Promise<FeedTokenStatusResponse> {
  const res = await fetch('/api/calendar/feed-token', { credentials: 'include' });
  if (!res.ok) throw new Error(`feed token status failed: ${res.status}`);
  return feedTokenStatusResponseSchema.parse(await res.json());
}

/** Mints (or regenerates — the server revokes any prior token) and returns the full raw
 * token. This is the only response that ever carries it. */
export async function mintFeedToken(): Promise<string> {
  const res = await fetch('/api/calendar/feed-token', { method: 'POST', credentials: 'include' });
  if (!res.ok) throw new Error(`feed token mint failed: ${res.status}`);
  return mintFeedTokenResponseSchema.parse(await res.json()).token;
}

export async function revokeFeedToken(): Promise<void> {
  const res = await fetch('/api/calendar/feed-token', { method: 'DELETE', credentials: 'include' });
  if (!res.ok) throw new Error(`feed token revoke failed: ${res.status}`);
}

/** Builds the full subscribe URL from a freshly minted raw token — same-origin, so this
 * works identically in dev (Vite proxy) and prod (behind Caddy). */
export function feedUrlFromToken(token: string): string {
  return `${window.location.origin}/api/calendar/feed/${token}.ics`;
}
